import ResCard from "./ResCard";
import { useEffect, useState } from "react";
import ShimmerCard from "./ShimmerCard";
import { API_URL, UPDATE_API } from "../utils/constants";
import Search_Icon from '../../assets/images/search_icon.png'
import { isEmptyObject } from "../utils/utils";

const Body = () => {
    const [resList, setResList] = useState([]);

    const [dupResList, setDupResList] = useState([]); // Hooks
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async () => {
        const data = await fetch(API_URL);
        const json = await data.json();
        setResList(json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
    };

    if (resList.length === 0) {
        return <ShimmerCard />
    }

    if (resList.length !== 0 && dupResList.length === 0) {
        setDupResList(resList);
    }

    const handleBtnClick = async () => {
        const data = await fetch(UPDATE_API, {
            method : 'POST',
            headers : {
                "content-type" : "application/json"
            },
            body : JSON.stringify({
                "lat": "28.65420",
                "lng": "77.23730",
                "nextOffset": "COVCELQ4KICIlOmH0NP6KjCnEw==",
                "filters": {},
                "page_type": "DESKTOP_WEB_LISTING",
                "_csrf": "StTY45ggshQP-2Rb1vpZMsHWrXhw4aHjGtztxYFI"
            })
        })
        const json = await data.json();
        console.log(json,'yes');
    }

    return (
        <div className="md:mx-36 sm:mx-24 mx-12">
            <div>
                <div className="flex justify-between flex-col md:flex-row">
                    <div className="relative md:w-2/5 w-full my-6">
                        <input type="text"
                            className="w-full p-2 border outline-none font-thin text-sm"
                            placeholder="Search Restaurent, Foods"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                                if (e.target.value.length === 0) setDupResList(resList);
                            }}
                        />
                        <img src={Search_Icon} className="absolute top-1 p-0 w-8 right-2"></img>
                    </div>

                    <div className="relative md:w-2/5 w-full my-6">
                        <input type="number" min={0} max={5} className="w-full p-2 border outline-none font-thin text-sm"
                            placeholder="Filter By Rating" id="filter_box" />
                        <button
                            className="absolute h-full px-2 bg-green-300 right-0"
                            onClick={() => {
                                const inputValue = document.getElementById("filter_box").value;
                                const num = +inputValue;
                                if (num < 0 || num > 5) {
                                    alert("Please! filter between 0 to 5");
                                }
                                else {
                                    const list = resList.filter((res) => res.info.avgRating >= num);
                                    if (list.length === 0) {
                                        alert("Sorry! No Restaurent Found above Rating " + num);
                                    }
                                    else setDupResList(list);
                                }
                            }
                            }> Filter
                        </button>
                    </div>
                </div>
            </div>

            <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-items-center">
                {dupResList.map((res) => {
                    return <ResCard props={res} key={res.info.id}></ResCard>
                })}
            </div>

            <div className="flex justify-center">
                <button className="border border-black p-2" onClick={handleBtnClick}>Click Here</button>
            </div>
        </div>
    );
};

export default Body;
